<div class="search-input-box position-relative" [ngStyle]="elementStyles.label">
  <input data-testid="auto-app-webbtree-company-search-input-1" type="text" placeholder="Search Company" (input)="onTypeAheadSearch($event)" [formControl]="typeahead_search"
    [matAutocomplete]="company_name" (keyup.enter)="search();" [ngStyle]="elementStyles.searchinput" class="text-truncate">
      <span
    class="clear-search pointer" [ngStyle]="elementStyles.clearSearch"
    *ngIf="typeahead_search?.value"
    (click)="clearSearch()"
  >
    <i class="fa-solid fa-xmark"></i>
  </span>
 <div *ngIf="showMainSearchLoader" class="spinner-border position-absolute text-webbtree-green"
              style="top:20px; right: 15.6%;" role="status"  [ngStyle]="elementStyles.spinnerPosition">
              <span class="sr-only">Loading...</span>
            </div>
  <span class="search-btn pointer" [ngStyle]="elementStyles.button" (click)="search()"><i
      class="fa-solid fa-search"></i></span>
  <span class="history-btn pointer" *ngIf="searchFrom == 'search'" [ngStyle]="elementStyles.history"
    (click)="openSearchHistory()">
    <i class="fa-regular fa-clock"></i>
  </span>
  <mat-autocomplete #company_name="matAutocomplete" [panelWidth]="scrollSearch ? '600px': ''">
    <div *ngIf="typeaheaddata?.length">
      <mat-option *ngFor="let data of typeaheaddata" [value]="data?.value" class="my-1">
        <span class="d-flex align-items-center w-100">
          <span (click)="selectTypeahead(data)">
            <span class="compnaylogoplaceholder mr-2"
              [ngClass]="{'bg-white': data?.companylogo , 'bg-color-company': !data?.companylogo}">
              <img [src]="data?.companylogo" *ngIf="data?.companylogo" class="img-fluid" alt="">
              <i class="fas fa-building f-12" *ngIf="!data?.companylogo"></i>
            </span>
          </span>
          <span class="text-truncate" (click)="selectTypeahead(data)">{{data.value | titlecase}}</span>
          <span class="d-flex flex-row justify-content-end ms-auto">
            <button data-testid="auto-app-webbtree-company-search-button-1" class="btn-trms-regular" style="width: fit-content; border-radius: .3125rem;"
              [ngClass]="{'disable-compare': getDisabledCompareButton(data.id)}"
              (click)="!getDisabledCompareButton(data?.id) && scrollTOCompareCompany($event, data)"
              *ngIf="searchFrom == 'search'">
              Compare
            </button>
            <button data-testid="auto-app-webbtree-company-search-button-2" class="ml-2 btn-trms-small px-0" style="width: fit-content; border-radius: .3125rem;"
              *ngIf="searchFrom == 'search'" (click)="redirecttoCompanylist(data)">
              View Insights
            </button>
            <button data-testid="auto-app-webbtree-company-search-button-3" class="btn-trms-regular" (click)="addCompanyForCompare(data)" *ngIf="searchFrom == 'modal'"
              [ngClass]="{'disable-compare': getDisabledCompareButton(data.id)}">
              +Add
            </button>
            <span class="icon-button mr-2" *ngIf="scrollSearch" title="Compare" (click)="!getDisabledCompareButton(data?.id) && scrollTOCompareCompany($event, data)">
              <i class="fa-solid fa-reflect-horizontal" [ngClass]="{'disable': getDisabledCompareButton(data.id)}"></i>
            </span>
     <span class="square-icon-button" *ngIf="scrollSearch" title="View Insights" (click)="redirecttoCompanylist(data)">
  <i class="fa-solid fa-chart-mixed"></i>
</span>

          </span>

        </span>
    </mat-option>
    </div>
    <div *ngIf="!typeaheaddata?.length && recentSearchData.length && searchFrom == 'search'" class="mt-2">
      <span class="f-12 text-9696 ml-3">Recent Searches</span>
      <mat-option *ngFor="let data of recentSearchData.slice(0,5)" (onSelectionChange)="selectRecentHistory(data)"
        class="my-1">
        <span class="d-flex align-items-center">
          <span>
            <span class="compnaylogoplaceholder mr-2"
              [ngClass]="{'bg-white': data?.companylogo , 'bg-color-company': !data?.companylogo}">
              <img [src]="data?.companylogo" *ngIf="data?.companylogo" class="img-fluid" alt="">
              <i class="fas fa-building f-12" *ngIf="!data?.companylogo"></i>
            </span>
          </span>
          <span class="text-truncate">{{data?.name}}</span>
          <span class="ms-auto gray-text f-12">
            {{(data?.type == 'company') ? 'Company': 'Company Comparison'}}
          </span>
        </span>
      </mat-option>
    </div>
  </mat-autocomplete>

</div>
